import React, { useState, useEffect } from 'react';
import './AgenticLoadingScreen.css';

const MESSAGES = [
  "Unser Agent sucht gerade die passenden Ergebnisse.",
  "Wir lieben KI Themen im Modul 16.\nKomm gerne auf uns zu, wenn du innovative Ideen umsetzen möchtest!",
  "Probier auch mal unsere Dialogsuche aus!",
];

const MESSAGE_DURATION = 7000; // 7 seconds

export default function AgenticLoadingScreen() {
  const [messageIndex, setMessageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const fadeOutTimer = setTimeout(() => {
      setIsVisible(false);
    }, MESSAGE_DURATION - 500); // Start fading out 500ms before switching

    const switchTimer = setTimeout(() => {
      setMessageIndex((prev) => (prev + 1) % MESSAGES.length);
      setIsVisible(true);
    }, MESSAGE_DURATION);

    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(switchTimer);
    };
  }, [messageIndex]);

  return (
    <div className="agentic-loading-container">
      <div className="spinner"></div>
      <div className={`agentic-loading-text ${isVisible ? 'visible' : 'hidden'}`}>
        {MESSAGES[messageIndex]}
      </div>
    </div>
  );
}
